import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { PacketReference } from '@core/models';

/**
 * Packet actions. The page requests a load of the (read-only) packet reference
 * data; the API (effect) reports the result.
 */
export const PacketPageActions = createActionGroup({
  source: 'Packet Page',
  events: {
    Entered: emptyProps(),
  },
});

export const PacketApiActions = createActionGroup({
  source: 'Packet API',
  events: {
    'Load Success': props<{ reference: PacketReference }>(),
    'Load Failure': props<{ error: string }>(),
  },
});
